module.exports = __webpack_public_path__ + "media/7.815f8142.mp3";